module.exports = __webpack_public_path__ + "img/scene_q_ttl_modal.466e4f66.png";